import { render } from "./pos-barcode.vue?vue&type=template&id=2158ddcb"
import script from "./pos-barcode.vue?vue&type=script&lang=js"
export * from "./pos-barcode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__